module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/am-36fc7db319e532bff785a981db0c3334.svg";